module.exports = __webpack_public_path__ + "static/media/Architecture_14.83fc3a47.jpg";